export class EmployeeUnitRequest{
    unitId: number;
    
    constructor(  unitId: number){
        this.unitId = unitId;
    }
}